import React, {CSSProperties, FC, Fragment, ReactElement, useState} from 'react';
import {Button, Modal} from "antd";
import {FeedbackRowProps} from "../../ActivityFeedbackRows/types";

export interface FeedbackModalContentFC<T extends FeedbackRowProps = FeedbackRowProps> extends FC<T> {
    title: string
}

interface Props {
    title: string
    width?: string
    bodyStyle?: CSSProperties
}

// TODO: Throws findDOMNode is deprecated in StrictMode
export const FeedbackModal: FC<Props> = ({title, children, width = '60%', bodyStyle}): ReactElement => {
    const [open, setOpen] = useState<boolean>(false);
    return (
        <Fragment>
            <Button onClick={() => setOpen(true)}>{title}</Button>
            <Modal 
                open={open}
                width={width} 
                style={{top: '25px'}} 
                bodyStyle={{
                    // 55px = modal header, 50px = spacing at the top + bottom
                    maxHeight: 'calc(100vh - 55px - 50px)',
                    overflow: 'auto',
                    ...bodyStyle
                }} 
                onCancel={() => setOpen(false)} 
                title={title} 
                footer={null}
            >
                {children}
            </Modal>
        </Fragment>
    );
};

